<template>
  <div class="keyword-planner-average-impression-column">
    {{ impressionPerDay }}
  </div>
</template>

<script>
export default {
  name: 'KeywordPlannerAverageImpressionColumn',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    impressionPerDay() {
      const STEP_UPPER_DELIMITER = 500;
      const STEP_BELOW_DELIMITER = 10;
      const DELIMITER = 1000;
      const number = this.row.searchCountPerDay;
      const step =
        number > DELIMITER ? STEP_UPPER_DELIMITER : STEP_BELOW_DELIMITER;
      const divided = number / step;
      const roundedDown = Math.floor(divided) * step;
      return `~${roundedDown}`;
    },
  },
};
</script>

<style lang="scss">
.keyword-planner-average-impression-column {
  unicode-bidi: plaintext;

  @include rtl() {
    text-align: right;
  }
}
</style>
